import IdleTimer from './IdleTimer';

export default IdleTimer;
